// extracted by mini-css-extract-plugin
export var chevronIcon = "_94-2";
export var teamName = "_94-1";
export var teamSwitcherButton = "_94-0";